import { render, staticRenderFns } from "./ComponentIndicators.vue?vue&type=template&id=2d05638d&scoped=true&"
import script from "./ComponentIndicators.vue?vue&type=script&lang=js&"
export * from "./ComponentIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05638d",
  null
  
)

export default component.exports